module.exports = __webpack_public_path__ + "assets/img/hcpimg1.2fc4ca52.png";